// eslint-disable-next-line no-unused-vars,no-undef
__webpack_public_path__ = window.DUMPERT_STATIC_HOST || '/';
